import { AxiosResponse } from 'axios';
import instance from '../../api/instance';
import { PackageSubscription } from './subscriptions.types';

export type GetRoomSubscriptions = (params: {
  companyId: string;
  roomId: string;
}) => Promise<AxiosResponse<PackageSubscription[]>>;

export const getRoomSubscriptions: GetRoomSubscriptions = async ({ companyId, roomId }) => {
  return instance.get(`companies/${companyId}/rooms/${roomId}/subscriptions`).catch(e => e.response as never);
};

export type PostNewRoomSubscription = (params: {
  companyId: string;
  roomId: string;
  data: { packageId: string };
}) => Promise<AxiosResponse<PackageSubscription[]>>;

export const postNewRoomSubscription: PostNewRoomSubscription = async ({ companyId, roomId, data }) => {
  return instance
    .post(`companies/${companyId}/rooms/${roomId}/subscriptions/activate`, data)
    .catch(e => e.response as never);
};
